"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SecondaryNavigation = exports.SecondaryNavigationDefaultProps = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("@shapeable/theme");
var link_1 = require("./link");
var use_entities_1 = require("../../hooks/use-entities");
var use_icons_1 = require("../../hooks/use-icons");
var lodash_1 = require("lodash");
var icon_1 = require("./icon");
var icon_label_1 = require("./icon-label");
exports.SecondaryNavigationDefaultProps = {
  items: [],
  divider: 'none'
};
// -------- Styles -------->
var BASE_SPACING = 3;
var ContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    position: relative;\n    font-size: ", ";\n    display: flex;\n    align-items: center;\n    min-width: 0;\n  "], ["\n    position: relative;\n    font-size: ", ";\n    display: flex;\n    align-items: center;\n    min-width: 0;\n  "])), theme_1.theme.FONT_SIZE(13)),
  tablet: (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    font-size: ", ";\n  "], ["\n    font-size: ", ";\n  "])), theme_1.theme.FONT_SIZE(14))
});
var ItemsStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    display: flex;\n    align-items: center;\n    overflow-x: auto;\n    margin: 0;\n    padding: ", " 0;\n    padding: 0;\n    -webkit-overflow-scrolling: touch;\n\n    &::-webkit-scrollbar {\n      display: none;\n    }\n  "], ["\n    display: flex;\n    align-items: center;\n    overflow-x: auto;\n    margin: 0;\n    padding: ", " 0;\n    padding: 0;\n    -webkit-overflow-scrolling: touch;\n\n    &::-webkit-scrollbar {\n      display: none;\n    }\n  "])), theme_1.theme.UNIT(2.5)),
  tablet: (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    padding: 0 0;\n  "], ["\n    padding: 0 0;\n  "])))
});
var ItemStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    display: flex;\n    font-size: 1em;\n    list-style: none;\n    font-weight: 400;\n    padding: 0;\n    padding-left: ", ";\n    transition: width 0.3s;\n    align-items: center;\n\n    &:first-child {\n      padding-left: 0;\n    }\n\n    ", "\n  "], ["\n    display: flex;\n    font-size: 1em;\n    list-style: none;\n    font-weight: 400;\n    padding: 0;\n    padding-left: ", ";\n    transition: width 0.3s;\n    align-items: center;\n\n    &:first-child {\n      padding-left: 0;\n    }\n\n    ", "\n  "])), theme_1.theme.UNIT(BASE_SPACING), function (props) {
    return props.divider === 'dotted' && (0, styled_components_1.css)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n      ", ";\n      margin-right: 6px;\n      background-position: top right;\n    "], ["\n      ", ";\n      margin-right: 6px;\n      background-position: top right;\n    "])), theme_1.theme.DOT_BG('v', 'line-mid', 2, 4));
  })
});
var LinkStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n    font-size: 1em;\n    white-space: nowrap;\n    font-weight: 500;\n    margin-right: ", ";\n\n    &:hover {\n      color: ", ";\n      ", ";\n    }\n\n    ", "\n\n    ", "\n\n  "], ["\n    font-size: 1em;\n    white-space: nowrap;\n    font-weight: 500;\n    margin-right: ", ";\n\n    &:hover {\n      color: ", ";\n      ", ";\n    }\n\n    ", "\n\n    ", "\n\n  "])), theme_1.theme.UNIT(BASE_SPACING), theme_1.theme.COLOR('link-hover'), theme_1.theme.FILL('link-hover'), function (props) {
    return props.isActive && (0, styled_components_1.css)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n      color: ", ";\n      ", ";\n    "], ["\n      color: ", ";\n      ", ";\n    "])), theme_1.theme.COLOR('primary'), theme_1.theme.FILL('primary'));
  }, function (props) {
    return props.isCurrent && (0, styled_components_1.css)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n      font-weight: 500;\n      &:hover {\n        cursor: default;\n        color: ", ";\n        ", ";\n      }\n    "], ["\n      font-weight: 500;\n      &:hover {\n        cursor: default;\n        color: ", ";\n        ", ";\n      }\n    "])), theme_1.theme.COLOR('dark'), theme_1.theme.FILL('dark'));
  })
});
var ControlsStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var IconStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n  "], ["\n  "]))),
  tablet: (0, styled_components_1.css)(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var LinkIconStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n    display: none;\n  "], ["\n    display: none;\n  "]))),
  tablet: (0, styled_components_1.css)(templateObject_14 || (templateObject_14 = __makeTemplateObject(["\n    display: block;\n  "], ["\n    display: block;\n  "])))
});
var LabelStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_15 || (templateObject_15 = __makeTemplateObject(["\n    margin-right: ", ";\n  "], ["\n    margin-right: ", ";\n  "])), theme_1.theme.UNIT(BASE_SPACING))
});
// -------- Components -------->
var My = {
  Container: styled_components_1.default.div(templateObject_16 || (templateObject_16 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Items: styled_components_1.default.ul(templateObject_17 || (templateObject_17 = __makeTemplateObject(["", ""], ["", ""])), ItemsStyles),
  Item: styled_components_1.default.li(templateObject_18 || (templateObject_18 = __makeTemplateObject([""], [""]))),
  Link: (0, styled_components_1.default)(link_1.Link)(templateObject_19 || (templateObject_19 = __makeTemplateObject(["", ""], ["", ""])), LinkStyles),
  LinkIcon: (0, styled_components_1.default)(icon_1.Icon)(templateObject_20 || (templateObject_20 = __makeTemplateObject(["", ""], ["", ""])), LinkIconStyles),
  IconLabel: (0, styled_components_1.default)(icon_label_1.IconLabel)(templateObject_21 || (templateObject_21 = __makeTemplateObject(["", ""], ["", ""])), LabelStyles),
  Icon: (0, styled_components_1.default)(icon_1.Icon)(templateObject_22 || (templateObject_22 = __makeTemplateObject(["", ""], ["", ""])), IconStyles),
  Controls: styled_components_1.default.div(templateObject_23 || (templateObject_23 = __makeTemplateObject(["", ""], ["", ""])), ControlsStyles)
};
My.Item = styled_components_1.default.li(templateObject_26 || (templateObject_26 = __makeTemplateObject(["\n  ", ";\n  ", "\n\n  ", "\n\n"], ["\n  ", ";\n  ", "\n\n  ", "\n\n"])), ItemStyles, function (props) {
  return props.divider === 'chevron' && (0, styled_components_1.css)(templateObject_24 || (templateObject_24 = __makeTemplateObject(["\n    ", " {\n      margin-right: ", ";\n    }\n  "], ["\n    ", " {\n      margin-right: ", ";\n    }\n  "])), My.Link, theme_1.theme.UNIT(BASE_SPACING + 0.5));
}, function (props) {
  return props.divider === 'dotted' && (0, styled_components_1.css)(templateObject_25 || (templateObject_25 = __makeTemplateObject(["\n    ", " {\n      margin-right: ", ";\n    }\n  "], ["\n    ", " {\n      margin-right: ", ";\n    }\n  "])), My.Link, theme_1.theme.UNIT(BASE_SPACING + 1.5));
});
var SecondaryNavigation = function (props) {
  var className = props.className,
    items = props.items,
    divider = props.divider;
  var icons = (0, use_icons_1.useIcons)();
  var entities = (0, use_entities_1.useEntities)();
  var ChevronRight = icons.ChevronRight;
  return react_1.default.createElement(My.Container, {
    className: className
  }, react_1.default.createElement(My.Items, null, (0, lodash_1.filter)(items).map(function (item, index) {
    var Icon = item.icon && item.icon({
      icons: icons,
      entities: entities
    });
    var hasDivider = (item.divider || divider !== 'none') && index !== items.length - 1;
    var dividerType = item.divider ? 'dotted' : divider;
    return react_1.default.createElement(My.Item, {
      divider: dividerType,
      hasDivider: hasDivider,
      key: "item-".concat(index)
    }, item.to ? react_1.default.createElement(My.Link, {
      iconSize: 18,
      isCurrent: item.isCurrent,
      isActive: item.isActive,
      to: item.to
    }, item.label) : react_1.default.createElement(My.IconLabel, {
      iconSize: 18,
      icon: Icon && react_1.default.createElement(Icon, null)
    }, item.label), divider === 'chevron' && index !== items.length - 1 && react_1.default.createElement(My.Icon, {
      color: "textMid",
      size: 10
    }, react_1.default.createElement(ChevronRight, null)));
  })));
};
exports.SecondaryNavigation = SecondaryNavigation;
exports.SecondaryNavigation.defaultProps = exports.SecondaryNavigationDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18, templateObject_19, templateObject_20, templateObject_21, templateObject_22, templateObject_23, templateObject_24, templateObject_25, templateObject_26;